import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.gaurd';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./shared/components/wallet-connection/wallet-connection.component').then((c) => c.WalletConnectionComponent)
    },
    {
        path: 'all-distribution-user-data', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/distribution-all-users/distribution-all-users.component').then((c) => c.DistributionAllUsersComponent),
    },
    {
        path: 'distribution-user-data/:mode', canActivate: [AuthGuard],
        loadComponent: () => import  ('./modules/components/distribution-user-data/distribution-user-data.component').then((c) =>c.DistributionUserDataComponent ),
    },
    {
        path: 'distribution-user-data-detail/:id/:mode', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/distribution-user-data/distribution-user-data-detail/distribution-user-data-detail.component').then((c) => c.DistributionUserDataDetailComponent),
    },
    {
        path: 'tokenomics', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/tokenomics/tokenomics.component').then((c) => c.TokenomicsComponent)
    },
    {
        path: 'distribution-plan', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/distribution-plan/distribution-plan.component').then((c) => c.DistributionPlanComponent)
    },
    {
        path: 'final-regular-distribution-plan', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/final-regular-distribution-plan/final-regular-distribution-plan.component').then((c) => c.FinalRegularDistributionPlanComponent)
    },
    {
        path: 'distribution-execution', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/distribution-execution/distribution-execution.component').then((c) =>c.DistributionExecutionComponent)
    },
    {
        path: 'global-final-distribution-execution', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/global-final-distribution-execution/global-final-distribution-execution.component').then((c) => c.GlobalFinalDistributionExecutionComponent)
    },
    {
        path: 'token-distribution-details/:year/:month', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/token-distribution/token-distribution.component').then((c) => c.TokenDistributionComponent),
    },
    {
        path: 'global-distribution-details/:year/:month', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/global-distribution/global-distribution.component').then((c) => c.GlobalDistributionComponent),
    },
    {
        path: 'token-distribution-history/:year/:month/:status', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/distribution-history/distribution-history.component').then((c) => c.DistributionHistoryComponent)
    },
    {
        path: 'failed-imports/:mode', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/failed-imports/failed-imports.component').then((c) => c.FailedImportsComponent)
    },
    {
        path: 'global-distribution-history', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/global-distribution-history/global-distribution-history.component').then((c) => c.GlobalDistributionHistoryComponent)
    },
    {
        path: 'announcement', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/announcement-management/announcement-management.component').then((c) => c.AnnouncementManagementComponent),

    },
    {
        path: 'announcement/create', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/announcement-management/create-announcement/create-announcement.component').then((c) => c.CreateAnnouncementComponent),
    },
    {
        path: 'announcement/edit/:id', canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/announcement-management/create-announcement/create-announcement.component').then((c) => c.CreateAnnouncementComponent),
    },
    {
        path: 'visitor-management',canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/visitor-management/visitor-management.component').then((c) => c.VisitorManagementComponent),
    },
    {
        path: 'visitor-management/member-space',canActivate: [AuthGuard],
        loadComponent: () => import ('./modules/components/member-space-visitors/member-space-visitors.component').then((c) => c.MemberSpaceVisitorsComponent)
    },
    {
        path:'banner-management',
        children: [
            {                
                path: '',
                canActivate:[AuthGuard],
                loadComponent: ()=> import('./modules/components/banner-management/banner-management.component').then((c) => c.BannerManagementComponent)
            },
            {
                path: 'create',
                canActivate:[AuthGuard],
                loadComponent: ()=> import('./modules/components/banner-management/banner-management-action/banner-management-action.component').then((c) => c.BannerManagementActionComponent)
            },
            {
                path: 'edit/:id',
                canActivate:[AuthGuard],
                loadComponent: ()=> import('./modules/components/banner-management/banner-management-action/banner-management-action.component').then((c) => c.BannerManagementActionComponent)
            }
        ]
    },
    {
        path:'audio-announcement',
        children: [
            {
                path: '',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/audio-announcement/audio-announcement.component').then(m => m.AudioAnnouncementComponent)
            },
            {
                path: 'create',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/audio-announcement/audio-announcement-actions/audio-announcement-actions.component').then(m => m.AudioAnnouncementActionsComponent)
            },
            {
                path: 'edit/:id',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/audio-announcement/audio-announcement-actions/audio-announcement-actions.component').then(m => m.AudioAnnouncementActionsComponent)
            }           
        ]
    },
    {
        path: 'deleted-failed-imports/:mode',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/deleted-failed-imports/deleted-failed-imports.component').then(m => m.DeletedFailedImportsComponent)
       
    },
    {
        path: 'usdt-transfer',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/usdt-transfer/usdt-transfer.component').then(m => m.UsdtTransferComponent)
    },
    {
        path: 'usdt-failed-imports',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/usdt-transfer/usdt-failed-imports/usdt-failed-imports.component').then(m => m.UsdtFailedImportsComponent)
    },
    {
        path: 'deleted-usdt-failed-imports',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/usdt-transfer/deleted-usdt-failed-imports/deleted-usdt-failed-imports.component').then(m => m.DeletedUsdtFailedImportsComponent)
    },
    {
        path: 'usdt-transaction-history',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/usdt-transfer/usdt-transaction-history/usdt-transaction-history.component').then(m => m.UsdtTransactionHistoryComponent)
    },
    {
        path: 'failed-distribution/:year/:month',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/token-distribution/failed-distribution/failed-distribution.component').then(m => m.FailedDistributionComponent)
    },
    // {
    //     path: 'amc-failed-distribution/:year/:month',
    //     canActivate: [AuthGuard],
    //     loadComponent: () => import('./modules/components/amc-token-distribution/amcfailed-distribution/amcfailed-distribution.component').then(m => m.AMCFailedDistributionComponent)
    // },
    {
        path: 'global-failed-distribution/:year/:month',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/global-distribution/global-failed-distribution/global-failed-distribution.component').then(m => m.GlobalFailedDistributionComponent)
    },

    {
        path: 'usdt-failed-transaction-history',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/usdt-transfer/usdt-failed-transaction-history/usdt-failed-transaction-history.component').then(m => m.UsdtFailedTransactionHistoryComponent)
    },
    {
        path:'tester-management',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/tester-management/tester-management.component').then(m => m.TesterManagementComponent)
    },
    {
        path: 'news-letter-management',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/news-letter/news-letter.component').then(m => m.NewsLetterComponent)
    },
    {
        path: 'referral-management',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/referral-management/referral-management.component').then(m => m.ReferralManagementComponent)
    },
    {
        path: 'view-tester-referral-detail/:id',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/referral-management/view-referral-details/view-referral-details.component').then(m => m.ViewReferralDetailsComponent)
    },
    {
        path: 'referral-timer',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/referral-management/referral-timer/referral-timer.component').then(m => m.ReferralTimerComponent)
    },
    {
        path:'excess-distribution-data',
        canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/token-distribution/excess-distribution-data/excess-distribution-data.component').then(m => m.ExcessDistributionDataComponent)
    },
    {
        path: 'final-distribution',
        redirectTo: 'final-distribution/rapture',
        pathMatch: 'full'
    },
    {
        path: 'final-distribution/:section', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/final-distribution/final-distribution.component').then((c) => c.FinalDistributionComponent)
    },
    {
        path: 'final-distribution/:section/:tab', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/final-distribution/final-distribution.component').then((c) => c.FinalDistributionComponent)
    },
    {
        path: 'final-distribution-synoptic',
        redirectTo: 'final-distribution-synoptic/synoptic-global',
        pathMatch: 'full'
    },
    {
        path: 'final-distribution-synoptic/:section', canActivate: [AuthGuard], data: { isSynoptic: true },
        loadComponent: () => import('./modules/components/final-distribution/final-distribution.component').then((c) => c.FinalDistributionComponent)
    },
    {
        path: 'final-distribution-synoptic/:section/:tab', canActivate: [AuthGuard], data: { isSynoptic: true },
        loadComponent: () => import('./modules/components/final-distribution/final-distribution.component').then((c) => c.FinalDistributionComponent)
    },
    // AOC BEP20 V2.1 Web2_Raptured FINAL DISTRIBUTION Data — new isolated module (see slug: raptured-final-distribution)
    {
        path: 'raptured-final-distribution', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/raptured-final-distribution/raptured-final-distribution.component').then((c) => c.RapturedFinalDistributionComponent)
    },
    {
        path: 'raptured-final-distribution/failed-imports', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/raptured-final-distribution/raptured-final-distribution-failed-imports/raptured-final-distribution-failed-imports.component').then((c) => c.RapturedFinalDistributionFailedImportsComponent)
    },
    {
        path: 'raptured-final-distribution/deleted-failed-imports', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/raptured-final-distribution/raptured-final-distribution-deleted-imports/raptured-final-distribution-deleted-imports.component').then((c) => c.RapturedFinalDistributionDeletedImportsComponent)
    },
];
